import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { exchangeCodeForTokens } from '../services/oauth'
import { useAuthStore } from '../stores/authStore'

export default function OAuthCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setUser } = useAuthStore()
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true

    const handleCallback = async () => {
      const code = searchParams.get('code')
      const error = searchParams.get('error')
      const state = searchParams.get('state')

      if (error) {
        navigate('/login?error=' + encodeURIComponent(error))
        return
      }

      if (!code) {
        navigate('/login?error=missing_code')
        return
      }

      try {
        const data = await exchangeCodeForTokens(code, state)

        setUser(data.user)
        navigate('/dashboard')
      } catch (err) {
        navigate(
          '/login?error=' +
            encodeURIComponent(err.message || 'token_exchange_failed')
        )
      }
    }

    handleCallback()
  }, [searchParams, navigate, setUser])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
        <p className="mt-4 text-gray-600">Completing authentication...</p>
      </div>
    </div>
  )
}
